import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AlertasService {

  constructor(private toast: ToastrService) { }

  showError(texto,titulo){
    this.toast.success(texto,titulo);
  }

  showSuccess(texto,titulo){
    this.toast.success(texto,titulo);
  }
}
